import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import bgStreamingContent from "../../assets/imgs/servicios/marketing/diseno.webp";
import bgStreaming from "../../assets/imgs/servicios/marketing/bg_mk_head.png";
import { useTranslation } from "react-i18next";
import { SubservicesTabs } from "../../components/subservicesTabs/subservicesTabs";
import { Gallery } from "../../components/gallery/gallery";

import ico01 from "../../assets/imgs/servicios/designweb/mk01.jpg";
import ico02 from "../../assets/imgs/servicios/designweb/mk02.jpg";
import ico03 from "../../assets/imgs/servicios/designweb/mk03.jpg";
import ico04 from "../../assets/imgs/servicios/designweb/mk04.jpg";
import ico05 from "../../assets/imgs/servicios/designweb/mk05.jpg";
import ico06 from "../../assets/imgs/servicios/designweb/mk06.jpg";
export const galleryDesigWeb = [ico01, ico02, ico03, ico04, ico05, ico06];

export const DesignWebPage = () => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    scrollToTop();
  });
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Diseño Gráfico - JC Innovation</title>
      </Helmet>
      <section className="wrapper__page_services">
        <div className="contain__head_page">
          <div className="container-lg">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="sec_head container_am">
                  <h3 className="ttls ttl_section c_morado mb-4">
                    {t("Diseño Gráfico")}
                  </h3>
                  <p className="paragraph lg">
                    {t(
                      "Cada congreso tiene su propia historia que contar. Nuestro equipo de diseño desarrolla identidades visuales únicas que transmiten la esencia de tu evento y refuerzan la experiencia de cada asistente."
                    )}
                  </p>
                  <h4 className="fw_600">
                    {t(
                      "Sabemos que el diseño no es un adorno, es el lenguaje visual de tu evento."
                    )}{" "}
                  </h4>
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-center">
                  <img src={bgStreaming} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contain_info__page ">
          <div className="container_am">
            <div className="text-center">
              <h3 className="ttls ttl_section mb-2">
                <span className="c_morado">
                  {t(
                    "Haz que tu congreso hable con fuerza, creatividad y profesionalismo."
                  )}
                </span>
              </h3>
            </div>
          </div>
          <div className="container-lg">
            <div className="row">
              <div className="col-md-4">
                {" "}
                <div className="col_info">
                  <h3 className="fw_600 mb-4 c_morado">
                    {t("¿Qué diseñamos? ")}
                  </h3>
                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>
                    {t(
                      "Identidad visual del evento, Logotipo, línea gráfica y branding completo."
                    )}
                  </p>
                  <hr />
                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t(
                      "Materiales impresos y digitales, Programas, gafetes, señalética, lonas, banners y souvenirs."
                    )}
                  </p>
                  <hr />

                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t(
                      "Presentaciones y fondos multimedia. Plantillas para ponentes, pantallas de bienvenida y visuales en vivo."
                    )}
                  </p>

                  <hr />
                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t(
                      "Campañas gráficas para redes sociales. Posts, historias y reels adaptados a la línea visual."
                    )}
                  </p>

                  <hr />
                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t(
                      "Diseño para stands y espacios físicos. Planos, renders y gráficos en gran formato para montaje."
                    )}
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                {" "}
                <div className="con_img_info">
                  <img src={bgStreamingContent} alt="" />
                </div>
              </div>
              <div className="col-md-4">
                <div className="col_info">
                  <h3 className="fw_600 mb-4 c_morado">{t("Beneficios")}</h3>
                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t(
                      "Identidad coherente y memorable en todos los puntos de contacto"
                    )}
                    .
                  </p>
                  <hr />

                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t("Experiencia visual que eleva el prestigio del evento")}.
                  </p>
                  <hr />

                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t("Materiales funcionales y estéticos al mismo tiempo")}.
                  </p>
                  <hr />

                  <p className="paragraph sm fw_300">
                    <span>
                      <i className="c_primary fa-solid fa-plus"></i>
                    </span>{" "}
                    {t(
                      "Creatividad respaldada por años de experiencia en congresos y grandes marcas"
                    )}
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SubservicesTabs />
        <Gallery images={galleryDesigWeb} title="Diseño gráfico" />
      </section>
    </>
  );
};
